import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { IStoreState } from "../../../../../reducers/types";
import { FlightBookPassengerSelection } from "./component";
import {
  getPackageAvailabilityAdultsCount,
  getPackageAvailabilityChildren,
} from "../../../../availability/reducer";
import { getFlightTripIdentity } from "../../../../flight-shop/utils/useFlightTripIdentity";

const mapStateToProps = (state: IStoreState) => {
  const { tripDetails } = getFlightTripIdentity(state);
  return {
    searchedAdultsCount: getPackageAvailabilityAdultsCount(state),
    searchedChildrenCount: getPackageAvailabilityChildren(state).length,
    tripDetails,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightBookPassengerSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFlightBookPassengerSelection = withRouter(
  connector(FlightBookPassengerSelection)
);
